export default {
	"goodsType": {
		"keyWordEmptyTips": "ต้องระบุคีย์เวิร์ด",
		"priority": "ลำดับความสำคัญ",
		"code": "พิมพ์รหัส",
		"defaultTemperatureType": "ประเภทการควบคุมอุณหภูมิเริ่มต้น",
		"defaultTemperatureRange": "ช่วงการควบคุมอุณหภูมิเริ่มต้น",
		"temperatureControlRange": "ช่วงอุณหภูมิที่ควบคุม",
		"keyword": "คำสำคัญ",
		"keywords": "คีย์เวิร์ด",
		"itemType": "ประเภทสินค้า",
		"keywordTips": "คำสำคัญ (กรอกเพื่อเพิ่ม)",
		"addGoodsType": "เพิ่มประเภทสินค้า",
		"editGoodsType": "แก้ไขประเภทสินค้า",
		"editGoodsTypeSuccess": "เปลี่ยนประเภทสินค้าแล้ว",
		"onlyCreateGoodsTypeSelectTips": "เลือกได้เฉพาะประเภทรายการที่มีสถานะใหม่เท่านั้น",
		"onlyEnableGoodsTypeSelectTips": "เลือกได้เฉพาะประเภทรายการที่ใช้งานอยู่เท่านั้น",
		"itemTypeCode": "รหัสประเภทสินค้า",
		"status": "สถานะ",
		"active": "ใช้งาน",
		"inactive": "ไม่ใช้งาน",
		"description": "คำอธิบาย",
		"enterItemType": "กรอกประเภทสินค้า",
		"enterItemNumber": "กรอกหมายเลขสินค้า",
		"enterTemperatureType": "เลือกประเภทอุณหภูมิ",
		"enterItemCode": "กรุณาใส่รหัสประเภทสินค้า",
		"enterKeyword": "กรอกคีย์เวิร์ด",
		"enterDescription": "กรอกคำอธิบาย",
		"action": "ดำเนินการ",
		"explainDetailKeywords": "กรอกคีย์เวิร์ด กรอกได้สูงสุด 10 ตัวอักษรต่อคีย์เวิร์ด, กด ‘Enter’ เพื่อเพิ่มคีย์เวิร์ดใหม่",
		"keywordIsRequired": "จำเป็นต้องระบุคีย์เวิร์ด"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/goodsType/goodsType.js